// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.stats-card-icon {
  color: var(--button-color, #007bff);
  flex-shrink: 0;
}

.stats-card-icon svg {
  width: 32px;
  height: 32px;
}

.stats-card-content {
  flex: 1 1;
}

.stats-card-title {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stats-card-value {
  font-size: 1.75rem;
  font-weight: 600;
  color: #333;
}

.stats-card-subtitle {
  font-size: 0.85rem;
  color: #999;
  margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Consumption/StatsCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".stats-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.stats-card-icon {\n  color: var(--button-color, #007bff);\n  flex-shrink: 0;\n}\n\n.stats-card-icon svg {\n  width: 32px;\n  height: 32px;\n}\n\n.stats-card-content {\n  flex: 1;\n}\n\n.stats-card-title {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stats-card-value {\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.stats-card-subtitle {\n  font-size: 0.85rem;\n  color: #999;\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
